/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Charging Status of the machine if its good or bad.
 *
 */
export var ChargingStatus;
(function (ChargingStatus) {
    ChargingStatus["GOOD"] = "Good";
    ChargingStatus["BAD"] = "Bad";
})(ChargingStatus || (ChargingStatus = {}));
